//Posição 0 usada como padrão
export default [
  {
    value: "Áreas Internas",
    interval: "200 m² a 2.500 m²",
    calcType: 1,
    subItems:[
      {
        value: "Pisos acarpetados",
        interval: "800 m² a 1.200 m²"
      },
      {
        value: "Pisos frios",
        interval: "800 m² a 1.200 m²"
      },
      {
        value: "Laboratórios",
        interval: "360 m² a 450 m²"
      },
      {
        value: "Almoxarifados/Galpões",
        interval: "1.500 m² a 2.500 m²"
      },
      {
        value: "Oficinas",
        interval: "1.500 m² a 1.800 m²"
      },
      {
        value: "Áreas com Espaços Livres - Saguão, Hall e Salão",
        interval: "1.000 m² a 1.500 m²"
      },
      {
        value: "Banheiros",
        interval: "200 m² a 300 m²"
      }
    ]
  },
  {
    value: "Áreas Externas",
    interval: "1.800 m² a 100.000 m²",
    calcType: 1,
    subItems:[
      {
        value: "Pisos Pavimentados Adjacentes/Contíguos às Edificações",
        interval: "1.800 m² a 2.700 m²"
      },
      {
        value: "Varrição de Passeios e Arruamentos",
        interval: "6.000 m² a 9.000 m²"
      },
      {
        value: "Pátios e Áreas verdes com Alta Frequência",
        interval: "1.800 m² a 2.700 m²"
      },
      {
        value: "Pátios e Áreas Verdes com Média Frequência",
        interval: "1.800 m² a 2.700 m²"
      },
      {
        value: "Pátios e Áreas Verdes com Baixa Frequência",
        interval: "1.800 m² a 2.700 m²"
      },
      {
        value: "Coleta de Detritos em Pátios e Áreas Verdes com Frequência Diária",
        interval: "100.000 m²"
      }
    ]
  },
  {
    value: "Esquadrias Externas",
    interval: "130 m² a 380 m²",
    calcType: 2,
    subItems:[
      {
        value: "Face Externa com Exposição a Situação de Risco",
        interval: "130 m² a 160 m²"
      },
      {
        value: "Face Externa sem Exposição a Situação de Risco",
        interval: "130 m² a 380 m²"
      },
      {
        value: "Face Interna",
        interval: "300 m² a 380 m²"
      }
    ]
  },
  {
    value: "Fachadas Envidraçadas",
    calcType: 2,
    interval: "130 m² a 160 m²"
  },
  {
    value: "Áreas Hospitalares e Assemelhadas",
    calcType: 1,
    interval: "360 m² a 450 m²"
  }
];


// WEBPACK FOOTER //
// ./src/utils/TypesOfM2.js